import { useIntl } from 'react-intl';

const useLocale = () => {
  const intl = useIntl();

  const t = (id: string, values?: Record<string, string | number>) => {
    return intl.formatMessage({ id }, values);
  };

  return { t, intl };
};

export default useLocale;
